import React from 'react';
import styled from 'styled-components';
import BannerImage from '../../images/home/AxisNeedSupport/banner-image.svg';
import Phone from '../../images/home/AxisNeedSupport/Phone.svg';
import Email from '../../images/home/AxisNeedSupport/Mail.svg';

const NeedSupportBanner = styled.div`
  background: linear-gradient(270deg, #d4d4d4 0%, #dcdcdc 100%);
  border-radius: 16px;
  padding: 16px 0px 16px 12px;
  margin: 16px auto;
`;

const PhoneEmailWrapper = styled.img`
  background: linear-gradient(180deg, #b1175d 0%, #7a004b 100%);
  border: 1px solid #7a004b;
  box-shadow: 0px 4px 10px 0px #00000029;
  padding: 8px;
  border-radius: 8px;
`;

export default function ContactSupport({ ele }) {
  return (
    <NeedSupportBanner>
      <div className="flex items-center justify-between gap-16px">
        <div>
          <div className="italic font-bold text-title-m mb-16px">
            Contact Support
          </div>
          {ele[0]?.elements?.map((item, index) => {
            return (
              <div className="flex items-center gap-12px mb-16px" key={index}>
                <div
                  className="italic font-medium text-title-s"
                  style={{ width: '104px' }}
                >
                  {item.title}
                </div>
                <a href={`tel: ${item.mobile}`}>
                  <PhoneEmailWrapper src={Phone} alt="phone" />
                </a>
                <a href={`mailto: ${item.email}`}>
                  <PhoneEmailWrapper src={Email} alt="email" />
                </a>
              </div>
            );
          })}
        </div>
        <img src={BannerImage} alt="axis-support" />
      </div>
    </NeedSupportBanner>
  );
}
